import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://izyxsiobttffsrmnpyez.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml6eXhzaW9idHRmZnNybW5weWV6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzczMzczODcsImV4cCI6MjA5MjkxMzM4N30.LbZ0H_CEUvxoNjsdVhg50PScKzu4Al70AOq1GvBvxTg';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);